module.exports = __webpack_public_path__ + "img/mailchimp.e0709fb6.png";